export const DUMMY_EXPERIENCE = [
    {
        id: 'e1',
        firmImageSrc: 'https://media.licdn.com/dms/image/C4E0BAQEO0lV3jqS-Ag/company-logo_200_200/0/1677697230469?e=1691625600&v=beta&t=p6-gRss2bj_VW5WO0ms9747OGaI01CYwwt60GrIox08',
        jobTitle: "Full Stack Developer",
        firmTitle: "Turkish Technology · Part Time",
        jobDate: "Jan 2022 - Present",
        jobPlace: "Istanbul, Turkey"
    },
    {
        id: 'e2',
        firmImageSrc: 'https://media.licdn.com/dms/image/D4D0BAQEnnBoR-CAO_w/company-logo_100_100/0/1680254075685?e=1691625600&v=beta&t=oTwWj3r9W4uonko4ba0VfikuKMNro--x_XxwsoXN6LQ',
        jobTitle: "Software Development Project Student",
        firmTitle: "BSH Turkey · Part Time",
        jobDate: "Agu 2022 - Dec 2022 · 4 months",
        jobPlace: "Istanbul, Turkey"
    },
    {
        id: 'e3',
        firmImageSrc: 'https://media.licdn.com/dms/image/C4D0BAQG9r50DSfZBUw/company-logo_100_100/0/1679386631096?e=1691625600&v=beta&t=hR1mOSgz2KuZMQJSbNsiv-Bdrxw62HSAnU9Azq8kcXI',
        jobTitle: "Backend Developer Intern",
        firmTitle: "Birlesik Ödeme · Internship",
        jobDate: "Oct 2021 - Agu 2022 · 10 months",
        jobPlace: "Istanbul, Turkey"
    },
    {
        id: 'e4',
        firmImageSrc: 'https://media.licdn.com/dms/image/C4D0BAQFiBJn3_SFnDQ/company-logo_200_200/0/1622372384333?e=1691625600&v=beta&t=upfN2m8q3DTMn2a0ODhjERV8iyIeJFy0D5LtKWNlERE',
        jobTitle: "Web Developer Intern",
        firmTitle: "MG UrbanFarmDe GmbH · Internship",
        jobDate: "Jul 2021 - Oct 2021 · 3 months",
        jobPlace: "Berlin, Germany"
    },
]